
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Isvg from 'react-inlinesvg';

import { FormGroup, Label, Input, FormFeedback, FormText, Button, Col, Row } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
import trashIcon from '../../../assets/svg/garbage.svg';

/**
* @author   Milan Stanojevic
*/
class AnalyticsParameterMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        let items = this.props.value ? this.props.value : [{}];
        return (
            <>
                <Row className='analytics-parameter-map'>
                    <Col lg="12">
                        <h6>{'Query parameter mapping'.translate(this.props.lang)}</h6>
                        {this.props.pixelType === 'google' ?
                            <p>{'Map URL query parameters (e.g. ?q, ?utm_source=) to GA4 event parameters'.translate(this.props.lang)}</p>
                            :
                            this.props.pixelType === 'meta' ?
                                <p>{'Map URL query parameters (e.g. ?q, ?utm_source=) to Meta event parameters'.translate(this.props.lang)}</p>

                                :
                                null}
                    </Col>

                    {
                        items.map((item, idx) => {
                            return (
                                <>
                                    <Col lg="3">
                                        <FormGroup>
                                            <Label size="sm">{'Query param'.translate(this.props.lang)}</Label>
                                            <Input type="text" size="sm" value={item.query} onChange={(e) => {
                                                if (!items[idx]) {
                                                    items[idx] = {

                                                    };
                                                }

                                                items[idx].query = e.target.value;
                                                this.props.onChange(items);
                                                this.forceUpdate();
                                            }}>

                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col lg="4">
                                        <FormGroup>
                                            <Label size="sm">{'Location'.translate(this.props.lang)}</Label>
                                            <Input size="sm" type="select" value={item.location} onChange={(e) => {
                                                if (!items[idx]) {
                                                    items[idx] = {

                                                    };
                                                }

                                                items[idx].location = e.target.value;
                                                this.props.onChange(items);
                                                this.forceUpdate();
                                            }}>
                                                <option value='params'>{this.props.pixelType === 'google' ? 'params' : this.props.pixelType === 'meta' ? 'custom_data' : null}</option>
                                                {this.props.pixelType === 'google' ? <option value='user_properties'>user_properties</option> : null}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col lg="4">
                                        <FormGroup>
                                            <Label size="sm">{'Param name'.translate(this.props.lang)}</Label>
                                            <Input size="sm" type="text" value={item.name} onChange={(e) => {
                                                if (!items[idx]) {
                                                    items[idx] = {

                                                    };
                                                }

                                                items[idx].name = e.target.value;
                                                this.props.onChange(items);
                                                this.forceUpdate();
                                            }}>

                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col lg="1">
                                        <button type='button' onClick={() => {
                                            let newValue = [...this.props.value];
                                            newValue.splice(idx, 1);
                                            this.props.onChange(newValue);
                                            this.forceUpdate()
                                        }}>
                                            <Isvg src={trashIcon} />
                                        </button>
                                    </Col>

                                </>
                            )
                        })
                    }

                </Row>
                <FormGroup className='analytics-parameter-map-add-new-container'>
                    <Button outline color="primary" size="sm" onClick={() => {
                        items.push({ location: 'params' });
                        this.props.onChange(items);
                        this.forceUpdate();
                    }}>{'Add new param'.translate(this.props.lang)}</Button>
                </FormGroup>
            </>
        );
    }
}

export default AnalyticsParameterMap;